// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"9a35af73","44":"8b27d1ea","117":"4d922be8","255":"f5f7bbe5","263":"f1318ecf","282":"40e161e6","374":"176b02eb","427":"6584be8e","508":"79045e6e","542":"13a06adb","617":"d0458707","732":"a38800b4","793":"88adef66","902":"5810ba5d","977":"fd0c37c1"}[chunkId] + ".chunk.js";
};